import { render, staticRenderFns } from "./JdhInputArea.vue?vue&type=template&id=1e8e3527&scoped=true&"
import script from "./JdhInputArea.vue?vue&type=script&lang=ts&"
export * from "./JdhInputArea.vue?vue&type=script&lang=ts&"
import style0 from "./JdhInputArea.vue?vue&type=style&index=0&id=1e8e3527&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e8e3527",
  null
  
)

export default component.exports